import { styled } from 'parkdepot-shared/theme'

export const TextSection = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    fontWeight: 400,
    color: '#222323'
}))

export const Container = styled<'div', { $backgroundColor: string }>('div', ({ $theme, $backgroundColor }) => ({
    backgroundColor: $backgroundColor,
    display: 'flex',
    gap: '1rem',
    padding: '1rem 0.5rem',
    marginTop: '1rem',

    [$theme.mediaQuery.large]: {
        width: '42rem',
        marginLeft: 'auto',
        marginRight: 'auto',
        borderRadius: '0.4rem'
    }
}))
